import { getUrl, Request } from "../../request";

export const getCategories = () => {
  return Request.get(getUrl("/api/v1/service_center/load-categories/"));
};

export const getAppointments = (
  category,
  start = null,
  end = null,
  q,
  sort = null
) => {
  return Request.get(getUrl("/api/v1/service_center/appointments/"), {
    ...(category !== null && { category }),
    ...(start && { start }),
    ...(end && { end }),
    ...(q && { q }),
    ...(sort && { [sort]: 1 }),
  });
};

export const getAppointment = (id) => {
  return Request.get(getUrl(`/api/v1/service_center/appointments/${id}/`));
};
